import type { FC, PropsWithChildren } from "react";
import { createPortal } from "react-dom";
import FocusLock from "react-focus-lock";
import { isBrowser } from "../../../utils/browser-utils";

type ModalPortalProps = PropsWithChildren<{
	show: boolean;
	disableFocusLock?: boolean;
	noAutoFocus?: boolean;
}>;

const ModalPortal: FC<ModalPortalProps> = ({
	show,
	disableFocusLock = false,
	noAutoFocus,
	children,
}) => {
	return isBrowser()
		? createPortal(
				<>
					{show && (
						<FocusLock
							disabled={disableFocusLock}
							{...(noAutoFocus ? { autoFocus: false } : {})}
						>
							{children}
						</FocusLock>
					)}
				</>,
				document.body,
			)
		: null;
};

ModalPortal.displayName = "ModalPortal";

export default ModalPortal;
